const BlockActionFunctionDefault = {
    name: 'Function',
    action_type: { name: 'function' },
    type: { name: 'action' },
    data: {
        functions: []
    },
    children: [
        { text: "", index: null, object_id: null, parent_block_id: null }
    ]
}

const BlockActionFunctionServerDefault = {
    name: 'Function',
    action_type: 'function'
}

export { BlockActionFunctionDefault, BlockActionFunctionServerDefault }
